import mergeDeepRight from 'ramda/src/mergeDeepRight'
import { CAMERA_SELECTED_COLORS } from 'helpers/globals'

const defaults = {
  color: CAMERA_SELECTED_COLORS['blue'],
  dropLength: 20, // in feet
  fillColor: '#000000',
  location: {},
  locked: false,
  notes: ''
}

export const addNetworkClosetDefaults = mergeDeepRight(defaults)
export default defaults



// WEBPACK FOOTER //
// ./src/helpers/networkClosets/defaults.js